import {CardSystem} from '@yandex-delivery/api/model/payment'

import dummySrc from './assets/dummy-card.svg'
import maestroSrc from './assets/maestro.svg'
import masterCardSrc from './assets/mastercard.svg'
import mirSrc from './assets/mir.svg'
import visaSrc from './assets/visa.svg'

export function getIconSrc(system?: CardSystem): string {
  switch (system) {
    case 'visa': {
      return visaSrc
    }
    case 'mastercard': {
      return masterCardSrc
    }
    case 'mir': {
      return mirSrc
    }
    case 'maestro': {
      return maestroSrc
    }
    default: {
      return dummySrc
    }
  }
}
